import { Command } from 'commander'

import { PreviewCommand } from '@/domains/project/preview'

import { CheckConfigCommand } from './check-config'
import { CreateCommand } from './create'
import { InitCommand } from './init'
import { PublishCommand } from './publish'
import { UpgradeCommand } from './upgrade'

const projectCommands = [
  InitCommand,
  CheckConfigCommand,
  CreateCommand,
  PreviewCommand,
  PublishCommand,
  UpgradeCommand,
]

const projectDomain = new Command('project')
projectDomain.description('Manage scalar project')
projectCommands.forEach((command) => projectDomain.addCommand(command()))
export default projectDomain
